// extracted by mini-css-extract-plugin
export default {"defaultLogo":"MG8TpAqyAtyymf3qmSFD","medium":"FMTILl3l6wmDrr_PXwYL","small":"pQtDugqItyKAVPJhQv6Y","customlogo":"A0KI7wrRezEZ8AI866Xd","customlogoWrapper":"yWlqQMGo4CiDjTtNIaYw"};